import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '90%',
    alignItems: 'flex-end',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#dbdbdb',
    marginTop: 30
  },
  mainTitle: {
    fontSize: 10,
    marginRight: 3
  },
  singleParagraph: {
    width: '100%',
    paddingHorizontal: 8,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    alignItems: 'flex-start',
    textAlign: 'right',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start'
  },
  singleParagraphShort: {
    width: '100%',
    paddingHorizontal: 8,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    alignItems: 'flex-end',
    textAlign: 'right',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start'
  },
  title: {
    fontSize: 7,
    color: 'black',
    flexDirection: 'row-reverse'
  },
  description: {
    fontSize: 7,
    textAlign: 'right',
    color: 'black',
    flexDirection: 'row-reverse'
  },
  titleContainer: {
    flexDirection: 'row',
    paddingHorizontal: 10,
    right: -12,
    top: -22
  },
  content: { width: '100%', marginTop: -12, padding: 4, paddingBottom: 8 }
})

export default styles
